

const HeroSlider: React.FC = () => {
  return (
    
    <section id="hero" className="paddingSlider">
        <div className="hero-left">
            <div className="hero-eyebrow">Istanbul Real Estate — Overseas Investment Specialists</div>
            <div className="hero-title">Where Capital<br/>Meets <em>Prime</em><br/>Property</div>
            <div className="hero-sub">Exclusive residential opportunities across Istanbul and Kocaeli — curated for the discerning international investor seeking growth, lifestyle, and citizenship.</div>
            <div className="hero-actions">
                <a className="btn-primary" href="#listings">View Listings</a>
                <a className="btn-ghost" href="#about">Learn More</a>
            </div>
        </div>

        <div className="hero-right investa-hero-right-column-direction">
            <div className="hero-investa-header-main">
                <div className="hero-title color-black">Elevated Living<br/>in the Heart <em>of the World’s Most</em><br/>Dynamic City.</div>
                <div className="hero-sub color-black">Unlock the gateway to premium living with our handpicked selection of ready-to-move and off-plan properties across Istanbul’s most prestigious districts. From Bosphorus views to high-yield residential hubs, we provide the market insight and personalized service needed to secure your family’s future in the Turkish Republic.</div>
                <div className="hero-actions"></div>
            </div>
            <div className="hero-stat-block investa-stats-block">
                <div className="hero-stat hero-stat-first">
                    <div className="hero-stat-num">400K</div>
                    <div className="hero-stat-label">USD — Citizenship Threshold</div>
                </div>
                <div className="hero-stat">
                <div className="hero-stat-num">+68%</div>
                <div className="hero-stat-label">Istanbul Property Growth (3Y)</div>
                </div>
                <div className="hero-stat">
                <div className="hero-stat-num">200+</div>
                <div className="hero-stat-label">Clients Placed Successfully</div>
            </div>
        </div>
            
        </div>
    </section>
 
  )

}

export default HeroSlider;